var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 18,
    viewBox: "0 0 18 18",
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m9.00008 17.3333c4.60242 0 8.33332-3.7309 8.33332-8.33329 0-4.60238-3.7309-8.333338-8.33332-8.333338-4.60237 0-8.333332 3.730958-8.333332 8.333338 0 4.60239 3.730962 8.33329 8.333332 8.33329zm4.79342-11.11341c.1138-.15438.0808-.37175-.0735-.48551-.1544-.11375-.3718-.08082-.4856.07357l-4.64674 6.30635-3.1901-2.55207c-.14975-.1198-.36825-.09552-.48805.05422-.11979.14975-.09551.36825.05423.48805l3.47222 2.7778c.07378.059.16842.0854.2621.0731s.1783-.0622.23435-.1383z",
    fill: "#2d9cdb",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCheck);
export default __webpack_public_path__ + "static/media/ico_check.9efa992d47c1fd26fc19eda9a947a70a.svg";
export { ForwardRef as ReactComponent };